import React, { useMemo } from "react";
import {
  phoneCountries,
  defaultPhoneCountry,
  formatMobileNumber,
  parseMobileNumber,
} from "../../utils/phoneCountries";

const PhoneNumberInput = ({
  id = "mobile",
  name = "mobile",
  value = "",
  onChange,
  onBlur,
  disabled = false,
  hasError = false,
  placeholder = "Enter phone number",
}) => {
  const { dialCode, nationalNumber } = useMemo(
    () => parseMobileNumber(value),
    [value]
  );

  const emitChange = (nextDialCode, nextNationalNumber) => {
    onChange({
      target: {
        name,
        value: formatMobileNumber(nextDialCode, nextNationalNumber),
      },
    });
  };

  const handleDialChange = (e) => {
    emitChange(e.target.value, nationalNumber);
  };

  const handleNumberChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "");
    emitChange(dialCode, digits);
  };

  return (
    <div className="input-group">
      <select
        className={`form-select ${hasError ? "is-invalid" : ""}`}
        style={{ maxWidth: "130px", flex: "0 0 130px" }}
        value={dialCode}
        onChange={handleDialChange}
        onBlur={onBlur}
        disabled={disabled}
        aria-label="Country code"
      >
        {phoneCountries.map((country) => (
          <option key={`${country.code}-${country.dial}`} value={country.dial}>
            {country.dial} {country.code}
          </option>
        ))}
      </select>
      <input
        type="tel"
        id={id}
        name={name}
        className={`form-control ${hasError ? "is-invalid" : ""}`}
        placeholder={placeholder}
        value={nationalNumber}
        onChange={handleNumberChange}
        onBlur={onBlur}
        disabled={disabled}
        inputMode="numeric"
        autoComplete="tel-national"
      />
    </div>
  );
};

export default PhoneNumberInput;
export { defaultPhoneCountry };
